import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { requiredFileType, requiredFileSize, markAllAsDirty, toFormData, ApiService } from 'src/app/_services/api.service';

@Component({
    selector: 'app-specificForm',
    templateUrl: './specificForm.component.html',
    styleUrls: ['./specificForm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpecificFormComponent {

  progress = 0;
  contactForm: any;
  success = false;
  requestValue = ""

  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService ) {
    this.contactForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      //ain: ['', Validators.required],
      ain: '',
      number: ['', Validators.required],
      direction: '',
      street: ['', Validators.required],
      type: '',
      unit: '',
      city: ['', Validators.required],
      zipCode: ['', Validators.required],
      description: '',
      email: ['', Validators.required],
      file: ['', [requiredFileType(''), requiredFileSize(10000000)]],
      buildingOrLand: [''],
      divormandc: [''],
      requestAddress : [''],
      disagreeValuation: [''],
      request: ['', Validators.required],
      recaptchaReactive: ['', Validators.required]
    });
    // file: ['', requiredFileType('pdf')],
  }

  changeRequest (value: string) {
    this.requestValue = value;
    this.contactForm.get('request').setValue(value);
    console.log(this.requestValue)
  }


  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }
    toFormData(this.contactForm.value)
    console.log(this.contactForm)

    this.apiService.sendForm(toFormData(this.contactForm.value), 'specific').subscribe(res => {
      console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      this.requestValue = '';
      console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

}

